import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useFeatureValue } from '@growthbook/growthbook-react';
import { LangCodeEnum } from 'shared/enums/LangCodeEnum';
import { FeatureFlags } from 'config/growthbook/featureFlags';
import { LangNamespaceEnum } from 'shared/enums/LangNamespaceEnum';
import { GrowthbookOverrides } from 'model/GrowthbookOverrides';
import { selectMeta } from 'selector/metaSelector';

export const useLanguageName = () => {
  const { t } = useTranslation(LangNamespaceEnum.SHARED);
  const companyId = useSelector(selectMeta)?.getCompanyId();

  const surveyFlagsOverrides = useFeatureValue<GrowthbookOverrides>(
    FeatureFlags.MULTI_LANGUAGE_SURVEY_FLAGS_OVERRIDES,
    []
  );

  const getLanguageName = (language: LangCodeEnum): string => {
    // Find override for this language and company
    const override = surveyFlagsOverrides.find(
      (override) =>
        override.language === language && override.companyId === companyId && override.nameOverride
    );

    // Use override name if available, otherwise use translation
    return override?.nameOverride || t('language.name', { lng: language });
  };

  return { getLanguageName };
};
